import { render, staticRenderFns } from "./ChampionshipEditor.vue?vue&type=template&id=6ae6b0fc"
import script from "./ChampionshipEditor.vue?vue&type=script&lang=js"
export * from "./ChampionshipEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports